import { useV2GetDocumentTemplateQuery } from "@generated";
import { DocumentTemplate } from "../../types";

const useGetDocumentTemplate = (id) => {
  // v2 infers the account from the auth token — no slug needed.
  const { data, isLoading, isFetching, refetch } =
    useV2GetDocumentTemplateQuery({ id: id });
  let template: DocumentTemplate | undefined = undefined;

  if (data?.data) {
    try {
      template = {
        id: String(data.data.id),
        active: data.data?.attributes?.["active"],
        name: data.data?.attributes?.name || "",
        format: data.data?.attributes?.format || "word_template",
        filenameFormat: data.data?.attributes?.["filename-format"],
        mergeTemplateFilename:
          data.data?.attributes?.["merge-template-filename"],
        //@ts-ignore
        downloadhref: data?.data?.links?.downloads,
        includeFormatting: data.data?.attributes?.["include-formatting"],
        templateFormat: data.data?.attributes?.["template-format"],
        teams:
          data.data.attributes?.teams?.map((t) => {
            return { value: t?.id || "", label: t?.name || "" };
          }) || [],
      };
    } catch (err) {
      if (err instanceof Error) {
        console.error(err.message);
      } else {
        console.error("An unknown error occurred");
      }
    }
  }

  return {
    template,
    isLoading,
    isFetching,
    refetch,
  };
};

export default useGetDocumentTemplate;
